/* AMBRA | assets/ambra-sticky-atc.js | v1.0.1 (pakiet Dodatki v1.2.1) | 10.10.2026 — pasek „Dodaj do koszyka” (desktop).
   Jedna przestrzeń window.AmbraStickyAtc. Bez nadpisywania fetch, bez MutationObserver. Motyw: tylko obserwacja
   .add-to-cart-block przy głównym formularzu (IntersectionObserver), odczyt input[name=id] tego formularza,
   zdarzenia eventBus variant:change / variant:updated (variant:null = niedostępny), update:cart:drawer,
   wetheme.updateCartCount. Zero nasłuchów na document. Szuflady nie otwieramy. */
(function () {
  'use strict';
  if (window.AmbraStickyAtc) { window.AmbraStickyAtc.init(); return; }
  var R = window.routes || {};
  var U = { add: (R.cart_add_url || '/cart/add') + '.js', cart: (R.cart_url || '/cart') + '.js' };

  /* v1.2.2: NAJPIERW formularz motywu data-type="add-to-cart-form" (ten z przyciskiem „Dodaj do koszyka”).
     Pierwszy formularz z adresem koszyka na stronie to niewidoczny (0 px) formularz rat Shop Pay, który motyw
     podmienia przy zmianie wariantu — obserwowanie go sprawiało, że pasek znikał na stałe po zmianie pojemności. */
  function poza(f) { return !!f.closest('#ThemeModal, [data-quick-view-product], [data-ambra-dod], .shopify-payment-terms__container'); }
  function glownyForm() {
    var fs = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    for (var i = 0; i < fs.length; i++) if (!poza(fs[i])) return fs[i];
    fs = document.querySelectorAll('form[action*="/cart/add"]');
    for (var j = 0; j < fs.length; j++) if (!poza(fs[j]) && fs[j].closest('.add-to-cart-block')) return fs[j];
    return null;
  }

  function start(root) {
    root.setAttribute('data-ambra-satc-ok', '');
    var d = root.dataset;
    var btn = root.querySelector('[data-ambra-satc-btn]');
    var cena = root.querySelector('[data-ambra-satc-cena]');
    var stara = root.querySelector('[data-ambra-satc-stara]');
    var wtyt = root.querySelector('[data-ambra-satc-wariant]');
    var status = root.querySelector('[data-ambra-satc-status]');
    var form0 = glownyForm();
    var kotwica = form0 && (form0.closest('.add-to-cart-block') || form0);
    if (!btn || !kotwica) return;
    var W = {};
    try { JSON.parse(root.querySelector('[data-ambra-satc-warianty]').textContent).forEach(function (w) { W[w.id] = w; }); } catch (e) {}
    var vid = +d.variantId;
    var dostepny = !btn.disabled;

    function mow(txt, blad) { status.classList.toggle('ambra-satc__status--blad', !!blad); status.textContent = txt; }

    function przycisk() {
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.disabled = !dostepny;
      btn.textContent = dostepny ? d.tDodaj : d.tBrak;
    }
    function wariant(id) {
      if (id === null) { dostepny = false; przycisk(); return; }
      var w = W[id];
      if (!w) return;
      vid = +id;
      dostepny = !!w.a;
      cena.textContent = w.c;
      if (w.o) cena.setAttribute('data-promo', ''); else cena.removeAttribute('data-promo');
      if (stara) { stara.textContent = w.o || ''; stara.hidden = !w.o; }
      if (wtyt) wtyt.textContent = w.t || '';
      przycisk();
    }
    function zForm() {
      var f = glownyForm();
      var inp = f && f.querySelector('input[name="id"]');
      if (inp) wariant(inp.value);
    }

    var io = new IntersectionObserver(function (es) {
      var e = es[es.length - 1];
      var nad = !e.isIntersecting && e.boundingClientRect.top < 0;
      root.classList.toggle('ambra-satc--widoczny', nad);
      root.setAttribute('aria-hidden', nad ? 'false' : 'true');
      if (!nad && document.activeElement === btn) btn.blur();
    }, { threshold: 0 });
    io.observe(kotwica);
    /* v1.2.2: gdyby motyw kiedyś podmienił obserwowany blok (np. przy zmianie wariantu), obserwujemy nowy. */
    function sprawdzKotwice() {
      if (document.contains(kotwica)) return;
      var f = glownyForm();
      var k = f && (f.closest('.add-to-cart-block') || f);
      if (!k) return;
      io.unobserve(kotwica); kotwica = k; io.observe(kotwica);
    }

    var bus = window.eventBus;
    if (bus && typeof bus.on === 'function') {
      var naWariant = function (ev) {
        setTimeout(sprawdzKotwice, 300);
        if (ev && ev.variant === null) wariant(null);
        else if (ev && ev.variant && ev.variant.id) wariant(ev.variant.id);
        else zForm();
      };
      bus.on('variant:change', naWariant);
      bus.on('variant:updated', naWariant);
    }

    btn.addEventListener('click', function () {
      if (!dostepny || btn.getAttribute('aria-busy') === 'true') return;
      var f = glownyForm();
      var q = f && f.querySelector('input[name="quantity"]');
      var ile = Math.max(1, parseInt(q && q.value, 10) || 1);
      btn.setAttribute('aria-busy', 'true');
      mow('');
      fetch(U.add, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: ile }], sections: 'cart-drawer' })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) {
          btn.textContent = d.tDodano;
          mow(d.tDodano);
          try { if (bus && typeof bus.emit === 'function') bus.emit(j.sections ? 'update:cart:drawer' : 'render:cart:drawer', j); } catch (e) {}
          return fetch(U.cart, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(c);
          }).catch(function () {});
        })
        .catch(function (e) { mow((e && e.description) || d.tBlad, true); })
        .then(function () {
          setTimeout(function () { btn.removeAttribute('aria-busy'); btn.textContent = dostepny ? d.tDodaj : d.tBrak; btn.disabled = !dostepny; }, 2000);
        });
    });
    zForm();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ambra-satc]:not([data-ambra-satc-ok])'), start);
  }
  window.AmbraStickyAtc = { init: init, wersja: '1.0.1' };
  init();
})();
